<div fxLayout="row wrap">
    <div fxFlex="50" fxFlex.xl="16.6" fxFlex.lg="16.6" fxFlex.md="33.3" fxFlex.sm="33.3" class="p-1">        
        <mat-card class="gradient-green tile p-1"> 
            <mat-icon>monetization_on</mat-icon> 
            <h2>$33500</h2>         
            <p>profit</p>            
        </mat-card>
    </div>
    <div fxFlex="50" fxFlex.xl="16.6" fxFlex.lg="16.6" fxFlex.md="33.3" fxFlex.sm="33.3" class="p-1">        
        <mat-card class="gradient-red tile p-1"> 
            <mat-icon>thumb_up_alt</mat-icon> 
            <h2>5300</h2>         
            <p>likes</p>            
        </mat-card>
    </div>
    <div fxFlex="50" fxFlex.xl="16.6" fxFlex.lg="16.6" fxFlex.md="33.3" fxFlex.sm="33.3" class="p-1">
        <mat-card class="gradient-orange tile p-1">
            <mat-icon>group</mat-icon> 
            <h2>14280</h2>         
            <p>users</p> 
        </mat-card>
    </div>
    <div fxFlex="50" fxFlex.xl="16.6" fxFlex.lg="16.6" fxFlex.md="33.3" fxFlex.sm="33.3" class="p-1">
        <mat-card class="gradient-pink tile p-1">
            <mat-icon>shopping_cart</mat-icon> 
            <h2>7520</h2>         
            <p>orders</p> 
        </mat-card>
    </div>
    <div fxFlex="50" fxFlex.xl="16.6" fxFlex.lg="16.6" fxFlex.md="33.3" fxFlex.sm="33.3" class="p-1">
        <mat-card class="gradient-gray tile p-1">
            <mat-icon>pie_chart</mat-icon> 
            <h2>$2700</h2>         
            <p>tax</p> 
        </mat-card>
    </div>  
    <div fxFlex="50" fxFlex.xl="16.6" fxFlex.lg="16.6" fxFlex.md="33.3" fxFlex.sm="33.3" class="p-1">
        <mat-card class="gradient-brown tile p-1">
            <mat-icon>save_alt</mat-icon> 
            <h2>12700</h2>         
            <p>downloads</p> 
        </mat-card>
    </div>      
</div>